export const MAX_CSV_FILE_SIZE_MB = 25;
export const CSV_FILE_TYPE_REQUIREMENT = "File type must be .csv";
export const CSV_FILE_SIZE_REQUIREMENT = `File size must be ${MAX_CSV_FILE_SIZE_MB}MB or less`;
